"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyColumnStats = exports.LegacyColumnCommonValue = exports.LegacyTableStats = exports.LegacyTableSampleValues = void 0;
exports.tableStatsFromLegacy = tableStatsFromLegacy;
exports.tableStatsToLegacy = tableStatsToLegacy;
exports.columnStatsFromLegacy = columnStatsFromLegacy;
exports.columnStatsToLegacy = columnStatsToLegacy;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
const legacyDatabase_1 = require("./legacyDatabase");
exports.LegacyTableSampleValues = zod_1.z.record(legacyDatabase_1.LegacyColumnValue);
// keep sync with frontend/src/Models/Project/TableStats.elm
exports.LegacyTableStats = zod_1.z.object({
    schema: legacyDatabase_1.LegacySchemaName.nullable(),
    table: legacyDatabase_1.LegacyTableName,
    rows: zod_1.z.number(),
    sample_values: exports.LegacyTableSampleValues
}).strict().describe('LegacyTableStats');
function tableStatsFromLegacy(s) {
    return (0, utils_1.removeUndefined)({
        schema: s.schema || undefined,
        entity: s.table,
        rows: s.rows,
        sampleValues: (0, utils_1.mapValues)(s.sample_values, legacyDatabase_1.columnValueFromLegacy)
    });
}
function tableStatsToLegacy(s) {
    return {
        schema: s.schema || null,
        table: s.entity,
        rows: s.rows,
        sample_values: (0, utils_1.mapValues)(s.sampleValues, legacyDatabase_1.columnValueToLegacy)
    };
}
exports.LegacyColumnCommonValue = zod_1.z.object({ value: legacyDatabase_1.LegacyColumnValue, count: zod_1.z.number() });
// keep sync with frontend/src/Models/Project/ColumnStats.elm
exports.LegacyColumnStats = zod_1.z.object({
    schema: legacyDatabase_1.LegacySchemaName.nullable(),
    table: legacyDatabase_1.LegacyTableName,
    column: legacyDatabase_1.LegacyColumnName,
    type: legacyDatabase_1.LegacyColumnType,
    rows: zod_1.z.number(),
    nulls: zod_1.z.number(),
    cardinality: zod_1.z.number(),
    common_values: exports.LegacyColumnCommonValue.array()
}).strict().describe('LegacyColumnStats');
function columnStatsFromLegacy(s) {
    return {
        schema: s.schema || undefined,
        entity: s.table,
        attribute: [s.column],
        type: s.type,
        rows: s.rows,
        nulls: s.nulls,
        cardinality: s.cardinality,
        commonValues: s.common_values.map(({ value, count }) => ({ value: (0, legacyDatabase_1.columnValueFromLegacy)(value), count }))
    };
}
function columnStatsToLegacy(s) {
    return {
        schema: s.schema || null,
        table: s.entity,
        column: s.attribute.join(legacyDatabase_1.legacyColumnPathSeparator),
        type: s.type,
        rows: s.rows,
        nulls: s.nulls,
        cardinality: s.cardinality,
        common_values: s.commonValues.map(({ value, count }) => ({ value: (0, legacyDatabase_1.columnValueToLegacy)(value), count }))
    };
}
//# sourceMappingURL=legacyStats.js.map